import axios from "../utils/axios";


//--------------------------------NEW INFRASTRUCTURE -------------------------------//
export const downloadExcelTemplate = () => {
    return axios.get(`/MasterData/ExcelSchema`, {
        responseType: "blob",
    });
};

export const getExcelJsonData = (payload) => {
    return axios.post(`/MasterData/ExcelToList`, payload);
};

export const uploadExcelFile = (payload) => {
    return axios.post(`/MasterData/PersistFromCache?fileChecksum=${payload}`);
}